export default{
    customerName: "",
    domainName: "",
    id:"",
    status:""
  }